import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetTransactionDetailsCommandReqData } from "./GetTransactionDetailsCommandReqData";
import { GetTransactionDetailsCommandResData } from "./GetTransactionDetailsCommandResData";

const ENDPOINT = "/cash_flow/transactions_additional_details";

export class GetTransactionDetailsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetTransactionDetailsCommandReqData = null;

    constructor(params: GetTransactionDetailsCommandReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetTransactionDetailsCommandResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetTransactionDetailsCommandResData(res);
    }
}
